module.exports = __webpack_public_path__ + "static/favicon-1b364d857208ae64043745d7bd2ffeb0.png";